export var PublicSettings;
(function (PublicSettings) {
    PublicSettings["APPLICATION_GROUPS_FORM"] = "APPLICATION_GROUPS_FORM";
    PublicSettings["CARD_NAME"] = "CARD_NAME";
    PublicSettings["CARD_STATE_COLOR"] = "CARD_STATE_COLOR";
    PublicSettings["EVENT_CATEGORIES"] = "EVENT_CATEGORIES";
    PublicSettings["NO_GROUP_SELECTED_NAME"] = "NO_GROUP_SELECTED_NAME";
    PublicSettings["PUBLIC_ABOUT_CARD_TEXT"] = "PUBLIC_ABOUT_CARD_TEXT";
    PublicSettings["PUBLIC_CLIENT_REGISTER_TEXT"] = "PUBLIC_CLIENT_REGISTER_TEXT";
    PublicSettings["PUBLIC_CLIENT_SITE_URL"] = "PUBLIC_CLIENT_SITE_URL";
    PublicSettings["PUBLIC_COLORS"] = "PUBLIC_COLORS";
    PublicSettings["PUBLIC_CONTACT_FORM_CONSENT"] = "PUBLIC_CONTACT_FORM_CONSENT";
    PublicSettings["PUBLIC_DEFAULT_CENTER"] = "PUBLIC_DEFAULT_CENTER";
    PublicSettings["PUBLIC_DEFAULT_MAP_LEVEL"] = "PUBLIC_DEFAULT_MAP_LEVEL";
    PublicSettings["PUBLIC_INDEX_PAGE_TEXT"] = "PUBLIC_INDEX_PAGE_TEXT";
    PublicSettings["PUBLIC_LOGO"] = "PUBLIC_LOGO";
    PublicSettings["PUBLIC_MAIN_IMAGE"] = "PUBLIC_MAIN_IMAGE";
    PublicSettings["PUBLIC_MOBILE_APP_LINKS"] = "PUBLIC_MOBILE_APP_LINKS";
    PublicSettings["PUBLIC_PARNTNER_BUTTON"] = "PUBLIC_PARNTNER_BUTTON";
    PublicSettings["PUBLIC_STYLE"] = "PUBLIC_STYLE";
    PublicSettings["PUBLIC_SOCIAL_MEDIA"] = "PUBLIC_SOCIAL_MEDIA";
    PublicSettings["PUBLIC_USEFUL_LINKS"] = "PUBLIC_USEFUL_LINKS";
})(PublicSettings || (PublicSettings = {}));
//# sourceMappingURL=publicSettings.enum.js.map